// Module
var code = " <p translate=\"DONATION_ITEM_RAISED\" class=\"item-amount-label\"></p> ";
// Exports
export default code;